import { Component, OnInit, HostListener } from '@angular/core';
import { CrearClienteComponent } from './crear-cliente/crear-cliente.component';
import { MatDialog } from '@angular/material/dialog';
import { TablesService } from '../generico/tables/tables.service';
import { ClientesService } from './clientes.service';

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss']
})
export class ClientesComponent implements OnInit {

  recurso ='clientes/admincliente';
  columnas = ['razon social','correo', 'estado', 'acciones'];
  nombre_tabla = 'tabla-clientes';
  target
  params = {}

  constructor(public dialog: MatDialog,
              private tb_serv : TablesService,
              private cli_serv : ClientesService) { }

  ngOnInit(): void {
    this.target = document.querySelector('#btn_crear_cliente');
  }

  crearClient() {
    const dialogRef = this.dialog.open(CrearClienteComponent, {
       width: '800px',
      height: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.tb_serv.tablas[this.nombre_tabla].cargar_datos(this.params);
      this.cli_serv.json_cliente = null;
    });
  }

  @HostListener('editar_cliente')
  editar_cliente(){
    this.cli_serv.json_cliente = this.tb_serv.params_event;
    this.crearClient();
  }

}
